// extracted by mini-css-extract-plugin
module.exports = {"bankNoc":"_2RkBH","validNoc":"omLVJ"};